import React from 'react';
import './Speakers from.css';
import AdvanSoft from "../../img/SF/AdvanSoft.png";
import Cruise from "../../img/SF/Cruise.png";
import Dell from "../../img/SF/Dell.png";
import Intel from "../../img/SF/Intel.png";
import Jackus from "../../img/SF/Jackus.png";
import SPGlobal from "../../img/SF/S&P Global.png";
import SIT from "../../img/SF/SIT.png";
import Swiggy from "../../img/SF/Swiggy.png";
import Adevinta from "../../img/SF/Adevinta.png";
import Comet from "../../img/SF/Comet.png";
import Nvidia from "../../img/SF/Nvidia.png";
import StarTree from "../../img/SF/StarTree.png";
import Thoughtworks from "../../img/SF/Thoughtworks.png";
import microsoft from "../../img/SF/microsoft.png";
import edpunk from "../../img/SF/edpunk.png";

const SpeakersFrom = (props) => { 
    const state = {
        Speakers_item: [
            {
                img: Nvidia,
            },
            {
                img: Dell,
            },
            {
                img: Intel,
            },
            {
                img: Thoughtworks,
            },
            {
                img: AdvanSoft,
            },
            {
                img: Comet,
            },
            {
                img: StarTree,
            },
            {
                img: Adevinta,
            },
            {
                img: Cruise,
            },
            {
                img: Jackus,
            },
            {
                img: SPGlobal,
            },
            {
                img: SIT,
            },
            {
                img: Swiggy,
            },
            {
                img: microsoft,
            },
            {
                img: edpunk,
            },
        ],
    };

    const renderSpeakers_item = (item, i) => {
        return (
            <div className="logo_item speakers_from_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt="Speakers logo" />
            </div>
        );
    };

    return (
        <div className="speakers_from_wrap">
            <div className="container">
                <h3>Speakers from</h3>
                <div className="speakers_from">
                    {state.Speakers_item.map((item, i) => renderSpeakers_item(item, i))}
                </div>
            </div>
        </div>
    );
};

export default SpeakersFrom;